export class ChoiceContentCustomItem {
    choiceText: string;
    isCorrect: boolean;
}
